import { Injectable } from '@angular/core';
import { IOrgLookupType } from '../../../enums/enums';
import { IRole, IRoleConfig } from '../../../models/models-index';
import { RuntimeConfigService } from '../runtime-config.service';

// @Injectable({ providedIn: 'root' })
@Injectable()
export class RoleConfigService {

  constructor(
    private runtimeConfigService: RuntimeConfigService
  ) { }


  isSysAdminRole(role: string) {
    return this.runtimeConfigService.isInOrgRole('systemAdministratorRoles', [role]);
  }

  isCorporateRole(role: string) {
    return this.runtimeConfigService.isInOrgRole('corporateRoles', [role]);
  }

  isOrg5Role(role: string) {
    return this.runtimeConfigService.isInOrgRole('org5Roles', [role]);
  }

  isOrg4Role(role: string) {
    return this.runtimeConfigService.isInOrgRole('org4Roles', [role]);
  }

  isOrg3Role(role: string) {
    return this.runtimeConfigService.isInOrgRole('org3Roles', [role]);
  }

  isOrg2Role(role: string) {
    return this.runtimeConfigService.isInOrgRole('org2Roles', [role]);
  }

  isOrg1Role(role: string) {
    return this.runtimeConfigService.isInOrgRole('org1Roles', [role]);
  }

  isDealerRole(role: string) {
    return this.runtimeConfigService.isInOrgRole('dealerRoles', [role]);
  }

  isDealerGroupRole(role: string) {
    return this.runtimeConfigService.isInOrgRole('dealerGroupRoles', [role]);
  }

  roleHasSysAdminAccess(role: string) {
    return this.isSysAdminRole(role);
  }

  roleHasCorporateAccess(role: string) {
    return this.roleHasSysAdminAccess(role)
      || this.isCorporateRole(role);
  }

  roleHasOrg5Access(role: string) {
    return this.roleHasCorporateAccess(role)
      || this.isOrg5Role(role);
  }

  roleHasOrg4Access(role: string) {
    return this.roleHasOrg3Access(role)
      || this.isOrg4Role(role);
  }

  roleHasOrg3Access(role: string) {
    return this.roleHasCorporateAccess(role)
      || this.isOrg3Role(role);
  }

  roleHasOrg2Access(role: string) {
    return this.roleHasOrg3Access(role)
    || this.isOrg2Role(role);
  }

  roleHasOrg1Access(role: string) {
    return this.roleHasOrg2Access(role)
    || this.isOrg1Role(role);
  }

  roleHasDealerAccess(role: string) {
    return this.roleHasOrg1Access(role)
    || this.isDealerRole(role);
  }
}
